if ($('.table-todolist tbody').length > 0) {
    // const tech = $('#todolist').hasClass('tech');
    // Plus de gestion par les techs depuis le portail en V1 donc const à false par défaut
    const tech = false;
    const todolistUpdate = tech ? 'todolists.tech.update' : 'todolists.customer.update';
    const todolistCreate = tech ? 'todolists.tech.create' : 'todolists.customer.create';
    const todolistDelete = tech ? 'todolists.tech.destroy' : 'todolists.customer.destroy';

    // Plus de gestion de priorité
    // new Sortable.Sortable($('.table-todolist tbody')[0], {
    //     animation: 150,
    //     ghostClass: 'blue-background-class',
    //     filter: '.static',
    //     onEnd: (evt) => {
    //         $.post({
    //             url: route(todolistUpdate, {
    //                 'id': evt.item.getAttribute('todo-id'),
    //                 'vp_regie_id': evt.item.getAttribute('customer-id'),
    //                 'companyNo': evt.item.getAttribute('customer-id'),
    //             }),
    //             data: {
    //                 '_token': $('input[name="_token"]')[0].value,
    //                 'order': evt.newIndex,
    //             },
    //         });
    //     },
    // });

    $('.table-todolist #todolist-add').on('click', (event) => {
        $.post({
            url: route(todolistCreate, {
                'event': $('#todolist-add').attr('data-event'),
                // 'vp_regie_id': $('#todolist-add').attr('data-company'),
            }),
            data: {
                '_token': $('input[name="_token"]')[0].value,
                'title': $('#todolist-title').val(),
                'ordre': $('#todolist-ordre').val(),
                'priorite': $('#todolist-priorite').val(),
            },
        }).done((data) => {
            $('#todolist-title').val('');
            $('#todolist-ordre').val('');
            $('#todolist-priorite').val('');

            $(data).insertBefore($('#todolist-customer .table-todolist tbody tr:last'));
        })
    });

    $('.table-todolist').on('click', '.edit', (event) => {
        const tr = $(event.target).closest('tr');
        tr.find('input').prop('disabled', false);
        tr.find('.edit').addClass('d-none');
        tr.find('.save').removeClass('d-none');
        tr.find('.cancel').removeClass('d-none');
    });

    $('.table-todolist').on('click', '.cancel', (event) => {
        const tr = event.target.closest('tr');

        $(tr).find('input').prop('disabled', true);

        tr.querySelectorAll('input.form-control').forEach((input) => {
            input.value = input.getAttribute('data-old');
        });

        $(tr).find('.edit').removeClass('d-none');
        $(tr).find('.save').addClass('d-none');
        $(tr).find('.cancel').addClass('d-none');
    });


    $('.table-todolist').on('click', '.delete', (event) => {
        const todolist_id = event.target.closest('tr').getAttribute('todo-id');
        const customer_id = event.target.closest('tr').getAttribute('customer-id');

        if (confirm('Êtes-vous sûr ?')) {
            $.ajax({
                url: route(todolistDelete, {
                    'companyNo': customer_id,
                    'vp_regie_id': customer_id,
                    'id': todolist_id,
                }),
                type: 'delete',
                data: {
                    _token: $('input[name="_token"]')[0].value,
                },
            }).done(() => {
                $('#todolist-' + todolist_id).remove();
            });
        }
    });

    $('.table-todolist').on('click', '.save', (event) => {
        const tr = event.target.closest('tr');

        const todolist_id = tr.getAttribute('todo-id');
        const customer_id = tr.getAttribute('customer-id');

        $.post({
            url: route(todolistUpdate, {
                'companyNo': customer_id,
                'vp_regie_id': customer_id,
                'id': todolist_id,
            }),
            data: {
                _token: $('input[name="_token"]')[0].value,
                title: $(tr).find('input[name="title"]')[0].value,
                contact: $(tr).find('input[name="contact"]')[0]?.value,
                deadline: $(tr).find('input[name="deadline"]')[0]?.value,
            },
        }).done(() => {
            $(tr).find('input').prop('disabled', true);
            $(tr).find('input.form-control').each(() => {
                event.target.setAttribute('data-old', event.target.value);
            });

            $(tr).find('.edit').removeClass('d-none');
            $(tr).find('.save').addClass('d-none');
            $(tr).find('.cancel').addClass('d-none');
        })
    });

    $('.table-todolist input[name="check"]').on('click', (event) => {
        const tr = event.target.closest('tr');

        const todolist_id = tr.getAttribute('todo-id');
        const customer_id = tr.getAttribute('customer-id');

        const routeUrl = event.target.closest('#todolist-customer') ? 'todolists.customer.update' : 'todolists.tech.update';

        $.post({
            url: route(routeUrl, {
                'companyNo': customer_id,
                'vp_regie_id': customer_id,
                'id': todolist_id,
            }),
            data: {
                _token: $('input[name="_token"]')[0].value,
                check: Number(event.target.checked),
            },
        }).done(() => {
            $(tr).find('input').css('text-decoration', event.target.checked ? 'line-through' : '');
            event.target.checked ? $(tr).find('a.btn').hide() : $(tr).find('a.btn').show();
        })
    });
}
